var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 244,
    viewBox: "0 0 256 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5637 1.59961H160.93L82.6904 233.42C81.0437 238.306 76.4637 241.593 71.3037 241.593H12.6504C6.02373 241.593 0.650391 236.22 0.650391 229.593C0.650391 228.286 0.863726 226.993 1.27706 225.753L74.177 9.77961C75.8237 4.89294 80.4037 1.59961 85.5637 1.59961Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.079 157.094H75.5654C72.5121 157.087 70.0321 159.567 70.0254 162.62C70.0254 164.16 70.6587 165.627 71.7854 166.674L148.585 238.354C150.819 240.44 153.765 241.6 156.825 241.6H224.499L195.079 157.094Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5616 1.5997C80.3416 1.5797 75.7216 4.9597 74.1483 9.93303L1.36831 225.566C-0.865021 231.793 2.37498 238.66 8.60164 240.893C9.90831 241.36 11.2883 241.6 12.6816 241.6H72.855C77.415 240.786 81.1883 237.58 82.7283 233.206L97.2416 190.433L149.082 238.786C151.255 240.586 153.982 241.58 156.802 241.6H224.228L194.655 157.093L108.448 157.113L161.202 1.5997H85.5616Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.823 9.76628C180.176 4.88628 175.603 1.59961 170.449 1.59961H86.4492C91.5959 1.59961 96.1759 4.88628 97.8159 9.75961L170.716 225.753C172.836 232.033 169.463 238.84 163.183 240.96C161.949 241.386 160.656 241.6 159.349 241.6H243.349C249.976 241.6 255.349 236.226 255.349 229.593C255.349 228.286 255.136 226.993 254.716 225.76L181.823 9.76628Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 113.035,
    y1: 19.3879,
    x2: 34.7641,
    y2: 250.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 137.481,
    y1: 127.138,
    x2: 119.377,
    y2: 133.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 128.079,
    y1: 12.4296,
    x2: 213.996,
    y2: 241.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.a4419965d19b7d2ed2dd0fe503e54cc9.svg";
export { ForwardRef as ReactComponent };